import {
  Button,
  Divider,
  Grid,
  LinearProgress,
  withStyles
} from '@material-ui/core';
import React from 'react';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { ReactComponent as IconMyFlags } from '../../images/icon-my-flags-highlight-2.svg';

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 4,
    borderRadius: 5,
    marginTop: 4,
    marginBottom: 4,
    marginLeft: 16,
    marginRight: 16
  },
  colorPrimary: {
    backgroundColor: '#3D434E'
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#E31690'
  }
}))(LinearProgress);

const ShareFlagsModalHeader = ({
  activeStep,
  onClose,
  onCreateGroup,
  setActiveStep,
  selectedGroupUsers,
  isCreatingGroup,
  inputGroupName
}) => {
  /**
   * This function handle Navigation of the modal. So:
   * 1. Active step 0 is the first main screen
   * 2. Active step 1 is the screen show for search only purpose
   * 3. Active step 10 is the 1st step to create a group
   * 4. Active step 11 is the 2nd step to create a group
   */

  const membersNumber = selectedGroupUsers.length;

  const handleBackNavButton = () => {
    if (activeStep === 1) {
      setActiveStep(0);
      return;
    }
    if (activeStep === 10) {
      setActiveStep(0);
      return;
    }
    if (activeStep === 11) {
      setActiveStep(10);
    }
  };

  const handleCreatePageNext = () => {
    setActiveStep(11);
  };

  const renderModalHeaderLeftPart = () => {
    if (activeStep === 0) {
      return (
        <Grid item xs={6} className="share-flags-modal__header-btn">
          <Button onClick={onClose}>Cancel</Button>
        </Grid>
      );
    }

    return (
      <Grid
        item
        xs={3}
        className="share-flags-modal__header-btn share-flags-modal__header-btn--back"
      >
        <Button onClick={handleBackNavButton}>
          <ChevronLeftIcon fontSize="large" />
        </Button>
      </Grid>
    );
  };

  const renderModalHeaderCenterPart = () => {
    if (activeStep === 10) {
      return (
        <Grid item xs={6} className="share-flags-modal__title-center">
          <span>{`${membersNumber} Members`}</span>
        </Grid>
      );
    }
    if (activeStep === 11) {
      return (
        <Grid item xs={6} className="share-flags-modal__title-center">
          <span>Name Group</span>
        </Grid>
      );
    }
  };

  const renderModalHeaderRightPart = () => {
    if (activeStep === 10) {
      return (
        <Grid
          item
          xs={3}
          className="share-flags-modal__header-btn share-flags-modal__header-btn--next"
        >
          <Button onClick={handleCreatePageNext}>Next</Button>
        </Grid>
      );
    }

    if (activeStep === 11) {
      return (
        <Grid
          item
          xs={3}
          className="share-flags-modal__header-btn share-flags-modal__header-btn--create"
        >
          <Button
            disabled={inputGroupName.trim().length === 0 || isCreatingGroup}
            onClick={onCreateGroup}
          >
            Create
          </Button>
        </Grid>
      );
    }

    return (
      <Grid item xs={6} className="share-flags-modal__header-brand">
        <div className="share-flags-modal__header-brand-container">
          <span className="action-title">Share In-App</span>
          {/* <i className="fa fa-bookmark-o" aria-hidden="true"/> */}
          <IconMyFlags />
        </div>
      </Grid>
    );
  };

  return (
    <div className="share-flags-modal__header">
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        style={{ marginBottom: '2px' }}
      >
        <>
          {renderModalHeaderLeftPart()}
          {renderModalHeaderCenterPart()}
          {renderModalHeaderRightPart()}
        </>
      </Grid>
      {isCreatingGroup && <BorderLinearProgress />}
      <Divider
        className="share-flags-modal__header-divider"
        variant="middle"
        style={{ marginBottom: '6px' }}
      />
    </div>
  );
};

export default ShareFlagsModalHeader;
